import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';

// Import your components
import Header from './components/Header.jsx';
import Hero from './components/Hero.jsx';
import MeetTheDoctor from './components/MeetTheDoctor';
import Pricing from './components/Pricing.jsx';
import Footer from './components/Footer.jsx';
import TermsAndConditions from './components/TermsAndConditions.jsx';
import EnquiryForm from './components/EnquiryForm.js';
import ContactSection from './components/ContactSection.jsx';
import ContactPage from './components/ContactPage.jsx';
import AboutUs from './components/AboutUs.jsx';
import ReviewsSection from './components/ReviewsSection.jsx';
import ServicesPage from './components/ServicesPage.jsx';

// ✅ Import Chatbot
import Chatbot from './components/Chatbot.jsx';

// A component for your main page content
const HomePage = ({ onOpenEnquiryForm }) => (
  <>
    <Hero onOpenEnquiryForm={onOpenEnquiryForm} />
    <MeetTheDoctor onOpenEnquiryForm={onOpenEnquiryForm} />
    <ReviewsSection onOpenEnquiryForm={onOpenEnquiryForm} />
    <Pricing onOpenEnquiryForm={onOpenEnquiryForm} />
    <ContactSection onOpenEnquiryForm={onOpenEnquiryForm} />
  </>
);

// ✅ Inner app wrapped inside Router so we can use useNavigate & useLocation
function AppInner() {
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ When URL is /enquiry, auto-open the form
  useEffect(() => {
    if (location.pathname === '/enquiry') {
      setShowEnquiryForm(true);
    }
  }, [location.pathname]);

  const handleOpenEnquiryForm = () => {
    setShowEnquiryForm(true);
    navigate('/enquiry'); // ✅ URL changes to /enquiry
  };

  const handleCloseEnquiryForm = () => {
    setShowEnquiryForm(false);
    navigate(-1); // ✅ Go back to previous URL when form closes
  };

  return (
    <div className="App">
      <Header onOpenEnquiryForm={handleOpenEnquiryForm} />

      <main>
        <Routes>
          {/* Route for the main landing page */}
          <Route
            path="/"
            element={<HomePage onOpenEnquiryForm={handleOpenEnquiryForm} />}
          />

          {/* ✅ /enquiry shows HomePage with form open on top */}
          <Route
            path="/enquiry"
            element={<HomePage onOpenEnquiryForm={handleOpenEnquiryForm} />}
          />

          {/* About Us */}
          <Route
            path="/about"
            element={<AboutUs onOpenEnquiryForm={handleOpenEnquiryForm} />}
          />

          {/* Services Page */}
          <Route
            path="/services"
            element={<ServicesPage onOpenEnquiryForm={handleOpenEnquiryForm} />}
          />

          {/* Contact Page */}
          <Route
            path="/contact"
            element={<ContactPage onOpenEnquiryForm={handleOpenEnquiryForm} />}
          />

          {/* Terms and Conditions */}
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </main>

      <Footer onOpenEnquiryForm={handleOpenEnquiryForm} />

      {/* Pop-up Enquiry Form */}
      <EnquiryForm
        isOpen={showEnquiryForm}
        onClose={handleCloseEnquiryForm}
      />

      {/* ✅ Floating AI Chatbot */}
      <Chatbot onOpenEnquiryForm={handleOpenEnquiryForm} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppInner />
    </Router>
  );
}

export default App;
